import { getData, postData } from '@core/utils/http/general'

//* Get path's availability
export const checkAvailabilityAccount = (m, k, p) => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 27,
    m,
    k,
    p,
  }
  getData(paramsRequest, 'wspublico')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data.message)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Send mail to change pass
export const sendMail = email => new Promise((resolve, reject) => {
  const data = new FormData()
  data.append('task', 'wspublico')
  data.append('origin', process.env.VUE_APP_ORIGIN_API)
  data.append('action', 26)
  data.append('email', email)

  postData(data)
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data.message)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

//* Change pass
export const changePass = (m, k, p, pass) => new Promise((resolve, reject) => {
  const data = new FormData()
  data.append('task', 'wspublico')
  data.append('origin', process.env.VUE_APP_ORIGIN_API)
  data.append('action', 28)
  data.append('m', m)
  data.append('k', k)
  data.append('p', p)
  data.append('x', pass)

  postData(data)
    .then(response => {
      if (response.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
